export default "__VITE_ASSET__BKRQEZKs__"